import React, { Component } from 'react';

import { connect } from 'react-redux'
import { dialogBtn1, 
         dialogBtn2, 
         dialogClose } from '../../store/actions'

import MsgDialog from '../../components/MsgDialog'

class CmsgDialog extends Component {
    render() {
        return (
            <MsgDialog
                body={this.props.body}
                btn1={this.props.btn1Txt}
                btn2={this.props.btn2Txt}
                header={this.props.header}
                handleBtn1={this.props.dialogBtn1}
                handleBtn2={this.props.dialogBtn2}
                close={this.props.dialogClose}
                open={this.props.open} />
        );
    }
}

const mapStateToProps = state => {
    return {
        body: state.msgDialog.dialogBody,
        btn1Txt: state.msgDialog.dialogBtn1Txt,
        btn2Txt: state.msgDialog.dialogBtn2Txt,
        header: state.msgDialog.dialogHeader,
        open: state.msgDialog.dialogOpen
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dialogBtn1:() => dispatch(dialogBtn1()),
        dialogBtn2:() => dispatch(dialogBtn2()),
        dialogClose:() => dispatch(dialogClose()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CmsgDialog);


// WEBPACK FOOTER //
// ./src/containers/CmsgDialog/index.js